import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../types";

const initialState: RootState['magento'] = {
  store: null,
  regProducts: [],
  colocatedRegProducts: []
};

const magentoSlice = createSlice({
  name: "magento",
  initialState,
  reducers: {
    setStore(state, action) {
      state.store = action.payload;
    },
    setRegProducts(state, action) {
      state.regProducts = action.payload;
    },
    setColocatedRegProducts(state, action) {
      state.colocatedRegProducts = action.payload;
    }
  }
});

export const { setStore, setColocatedRegProducts, setRegProducts } = magentoSlice.actions;

export default magentoSlice.reducer;